import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation/Navigation';
import Hero from './components/Hero/Hero';
import ServicesGrid from './components/ServicesGrid/ServicesGrid';
import Pricing from './components/Pricing/Pricing';
import FAQ from './components/FAQ/FAQ';
import About from './components/About/About';
import ContactForm from './components/ContactForm/ContactForm';
import Footer from './components/Footer/Footer';
import CookieBanner from './components/CookieBanner/CookieBanner';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import DeepDivePage from './components/DeepDivePage/DeepDivePage';
import './App.css';

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace('#', '');

    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }

    window.requestAnimationFrame(() => {
      const element = document.getElementById(hash);

      if (!element) {
        return;
      }

      const offsetTop = element.offsetTop - 80;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    });
  }, [location.pathname, location.hash]);

  return null;
}

function HomePage() {
  return (
    <>
      <div className="starfield"></div>
      <Navigation />
      <main>
        <section id="home">
          <Hero />
        </section>
        <section id="services">
          <ServicesGrid />
        </section>
        <section id="pricing">
          <Pricing />
        </section>
        <section id="faq">
          <FAQ />
        </section>
        <section id="about">
          <About />
        </section>
        <section id="contact">
          <ContactForm />
        </section>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about-leviathan" element={<DeepDivePage slug="about-leviathan" />} />
          <Route path="/web-developer-widnes" element={<DeepDivePage slug="web-developer-widnes" />} />
          <Route path="/digital-growth" element={<DeepDivePage slug="digital-growth" />} />
        </Routes>
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;
